import { NextPageContext } from 'next';

import { SeoMetaObject } from 'src/components/pageMeta/SEOMetaTypes';
import { ContentTypes } from 'src/components/thumbnail/types';
import { ContentLiteData } from 'src/types/consumption';
import { StateCode } from 'src/utils/constants/stringConstants';
import {
  FeatureFlagConstants,
  REMOTE_CONFIG,
  USER_LOCATION_DATA
} from 'src/utils/constants/utilConstants';
import { getServerData } from 'src/utils/ConsumptionHelper/ConsumptionHelperForServer';
import { contentSpecificChecks } from 'src/utils/ConsumptionHelper/MovieConsumptionHelper';
import { isFeatureEnabled } from 'src/utils/RemoteConfig';

import SimpleStore from 'src/store/SimpleStore';
import ConsumptionPage from '../../../../components/consumptionPage';

type MovieConsumptionWrapperProps = {
  contentLiteData: ContentLiteData;
  botRails: any;
  seoMetaObject: SeoMetaObject;
  seoMetaAssets: any;
};

const MovieConsumptionWrapper = ({
  contentLiteData,
  botRails,
  seoMetaObject,
  seoMetaAssets
}: MovieConsumptionWrapperProps) => {
  return (
    <ConsumptionPage
      pageDetails={{
        contentType: ContentTypes.movies
      }}
      contentLiteData={contentLiteData}
      botRails={botRails}
      seoMetaObject={seoMetaObject}
      seoMetaAssets={seoMetaAssets}
    />
  );
};

export default MovieConsumptionWrapper;

export async function getServerSideProps(context: NextPageContext) {
  const remoteConfig = SimpleStore.get(REMOTE_CONFIG);
  const usersLocationData = SimpleStore.get(USER_LOCATION_DATA);

  const stateCode = usersLocationData || StateCode.KA;

  const seoBotsConsumptionRailsEnabled = isFeatureEnabled(
    remoteConfig,
    FeatureFlagConstants.FEATURE_SEO_CONSUMPTION_RAILS
  );

  const movieId = context.query?.movieId as string;
  const movieTitle = context.query?.movieTitle as string;
  const pathName = decodeURI(context.req?.url as string);

  const contentObject = contentSpecificChecks(movieId, movieTitle, pathName);
  if (contentObject) {
    return {
      ...contentObject
    };
  }

  const serverResponse = await getServerData({
    context,
    contentId: movieId,
    contentType: ContentTypes.movies,
    seoBotsConsumptionRailsEnabled,
    stateCode
  });

  return {
    ...serverResponse
  };
}
